import { default as cn } from 'classnames';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import { useDispatch, useSelector } from 'react-redux';
import ImageViewer from 'react-simple-image-viewer';
import close from '../../../../assets/media/icons/close.svg';
import lock_icon from '../../../../assets/media/icons/free-icon-lock-93140.svg';
import unlock_icon from '../../../../assets/media/icons/free-icon-open-lock-93144.svg';
import okay3 from '../../../../assets/media/icons/okay10.svg';
import plus from '../../../../assets/media/icons/plus.svg';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button, ButtonWithTooltip } from '../../../../components/Basic/Buttons';
import { DropDown, Icon, Link } from '../../../../components/Basic/Elements';
import { DateInput, Input, Select } from '../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import BarcodesBlock from '../../../../components/Common/Input/Barcodes';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import CommissionNdsBlock from '../../../../components/Markets/Blocks/CommissionNdsBlock';
import CommissionWbBlock from '../../../../components/Markets/Blocks/CommissionWbBlock';
import BarcodePopUp from '../../../../components/Markets/Blocks/Table/Line/barcodePopUp';
import PackagingMethodSelect from '../../../../components/Providers/Inputs/PackagingMethodSelect';
import PostingStatusWrap from '../../../../components/Shipments/WrapStyle/PostingStatus';
import { getDate, numberWithSpaces } from '../../../../utils';
import { GO_TO_WB } from '../../WbStorage/Table/Line';
import { WIDTH_POSTING } from '../index';
import ProfitBlock from './ProfitBlock';
import styles from './styles.module.scss';


const SupplyItemLine = ({
  maxDateOrdersCount,
  packageMethods,
  pricesMode,
  manySupplies,
  isOwner,
  isUser,
  MODES,
  FILTER,
  tab,
  mode,
  product,
  printSticker = (_) => _,
  boxes = [],
  changeProductsInSupply = (_) => _,
  onChangeCard = (_) => _,
  getByDateStat = (_) => _,
  ...props
}) => {

  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [isOpenPostingsArray, setIsOpenPostingsArray] = useState(false);
  const [images, setImages] = useState([]);
  const [providers, setProviders] = useState([]);
  const [info, setInfo] = useState(false);
  const dispatch = useDispatch();
  const allProviders = useSelector((store) => store.providers);


  // список поставщиков
  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders(p);
    }
  }, [allProviders]);

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };




  // const scan_time_order = product.boxes?.scan_time?.pick ? formFullDateWithSeconds(product.boxes?.scan_time.pick) : null;
  // const second_scan_time_order = product.boxes?.scan_time?.packager ? formFullDateWithSeconds(product.boxes?.scan_time.packager) : null;
  // const sort_scan_time_order = product.boxes?.scan_time?.sort ? formFullDateWithSeconds(product.boxes?.scan_time.sort) : null;

  const data = product.card || {}
  const img = data?.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
  const square = +(2 * (data.sizes_package?.height * data.sizes_package?.width + data.sizes_package?.height * data.sizes_package?.depth + data.sizes_package?.depth * data.sizes_package?.width) / 10000)?.toFixed(2)

  const colorLine = (() => {
    if (mode === MODES[0] && product?.processed_quantity === product.processed_quantity) return '#39ee3f35'
    if (mode === MODES[1] && (product?.total?.sold?.count + product?.total?.cancel?.return_pvz_count) === product.processed_quantity) return '#39ee3f35'
  })()

  return (
    <React.Fragment>
      {mode !== MODES[2] ?
        (<>
          <TableLine style={{ background: colorLine }}
          >
            {mode !== MODES[1] && (
              <TableCell width={WIDTH_POSTING[10]} center={true}>
                <Row>
                  <BarcodePopUp
                    product={product}
                    onPrint={printSticker}
                  // noAdd={true}
                  />
                </Row>
              </TableCell>
            )}
            <TableCell width={WIDTH_POSTING[15]} center={true}>
              {product.market === 'wb' && (
                <TextGrey style={{ fontSize: '13px', color: '#6c11c9', marginBottom: '3px' }}>{product.shop}
                  {manySupplies && <div style={{ color: '#00000090' }}> ({product.supply_id})</div>}
                </TextGrey>
              )
              }
              {product.market === 'yandex' && (
                <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{product.shop}</TextGrey>
              )}
              {product.market === 'ozon' && (
                <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{product.shop}</TextGrey>
              )}
              {product.market === 'megamarket' && (
                <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{product.shop}</TextGrey>
              )}
              <div className={styles.scan_time} onMouseOver={() => setInfo(true)} onMouseLeave={() => setInfo(false)}>
                <span style={{ fontSize: '11px', lineHeight: '12px' }}>{product.packager?.name}</span> <br />
                {info && (product.scan_history?.length > 0) && mode !== MODES[0] && (
                  <DropDown styles={styles.all_info}>
                    <div style={{
                      margin: '10px',
                      marginTop: '20px'
                      // paddingTop: '10px'
                    }}>
                      <div
                        style={{
                          textAlign: 'left',
                          color: '#0000006c',
                          fontSize: '20px',
                          marginBottom: '5px'
                        }}
                      >
                        <span
                          style={{
                            fontSize: '14px',
                          }}
                        > Упаковщик: <span style={{ fontSize: '16px', color: '#000000c3' }}>{product.packager.name}</span></span>
                        <span style={{ fontSize: '14px' }}> (ставка: {product.scan_pay.packager} руб.)</span>
                      </div>
                      <WhiteBlock
                        style={{
                          minWidth: 'max-content',
                          padding: '20px',
                          marginBottom: '0px',
                          maxHeight: '400px', overflowY: 'scroll',
                        }}
                      >
                        {product.scan_history?.map((hel, i) =>
                          <Row key={hel._id}>
                            <div style={{ fontSize: '11px', color: '#00000061', marginRight: '3px', minWidth: '20px' }}>{i + 1}.</div>
                            <div style={{ color: hel.role === 'packager' ? '#015170ac' : '#00842cab', marginRight: '15px', minWidth: '70px' }}>{moment(hel.date).format('DD.MM HH:mm')}</div>
                            <div style={{ color: hel.role === 'packager' ? '#003448c1' : '#004a19cc', marginRight: '5px' }}>{hel.role === 'packager' ? 'Упаковал(а)' : 'Напечатал(а)'}</div>
                            <div style={{ fontWeight: 'bold', color: '#000000ae', marginRight: '5px', }}>{hel.name}</div>
                            {hel.role === 'packager' && < div style={{ color: '#00000066', marginRight: '5px' }}>(sid: {hel.scaner_id})</div>}
                            {(hel.role !== 'packager' && hel.count) && < div style={{ marginRight: '5px' }}>({hel.count} этикеток)</div>}
                          </Row>
                        )}

                        {/* <TextGrey style={{ marginBottom: '4px' }}>Пропик:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${1}`}</Text>
                      <div className={styles.scan_time}>({ })</div> */}

                        {/* {second_scan_time_order && (
                        <>
                          <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Упаковка:</TextGrey>
                          <Text fontSize={18} fontWeight={600}>{`${product.boxes?.scan_user.packager}`}</Text>
                          <div className={styles.scan_time}>
                            ({second_scan_time_order}){' '}
                            {product.scan_id.packager && (
                              <span>
                                {' '}
                                - сканер id: <span style={{ fontWeight: '600' }}>{product.scan_id.packager}</span>{' '}
                              </span>
                            )}
                          </div>
                        </>
                      )} */}
                      </WhiteBlock>
                    </div>
                  </DropDown>
                )}
              </div>
            </TableCell>
            {mode !== MODES[1] && (
              <>
                <TableCell width={WIDTH_POSTING[10]} center={true}>
                  <Row style={{ width: '100%' }}>
                    <Select
                      updateValue={{}}
                      style={{ marginRight: '3px' }}
                      center
                      fontSize={'18px'}
                      select={product.boxes?.box_number || '-'}
                      // list={[...(boxes.map(b => b.id).filter(b => !product.boxes_numbers.includes(b)) || []), 'Нет']}
                      list={[...(boxes.map(b => b.id) || []), 'Нет']}
                      onSelect={(v) => changeProductsInSupply({ action: 'change_box_number', shop: product.shop, supplyId: product.supply_id, offerId: product.offer_id, boxId: product._id, value: +v })}
                    />
                    <img
                      src={plus} style={{ cursor: 'pointer', width: '22px' }}
                      onClick={(v) => changeProductsInSupply({ action: 'add_box', shop: product.shop, supplyId: product.supply_id, offerId: product.offer_id, boxId: product._id })}
                    // onCls
                    />
                  </Row>

                </TableCell>
                <TableCell width={WIDTH_POSTING[8]} center={true}>
                  <div style={{ marginTop: '7px', color: '#000000b7', fontSize: '19px', fontWeight: 'bold' }} className={styles.div_line}>
                    {product.processed_quantity} / {product.ordered_quantity}
                  </div>
                </TableCell>
              </>
            )}
            <TableCell width={WIDTH_POSTING[18]}>
              <div className={styles.div_line_images}>
                <div className={styles.wrapper}>
                  <img
                    onClick={() => openImageViewer(img)}
                    className={styles.preview}
                    src={img.length > 0 ? img[0] : undefined}
                  />
                </div>
                <div
                  style={{ fontSize: '13px' }}
                  className={styles.name}>
                  {`${product.name}  `}
                  {/* <div className={cn(styles.offer_id)}>
                    {product.offer_id}
                  </div> */}
                  <Link
                    blue={true}
                    className={cn(styles.offer_id)}
                    href={GO_TO_WB(product.card?.nmID)}
                    style={{ width: 'auto', fontSize: '10px', userSelect: 'auto' }}
                    target={'_blank'}
                  >
                    {/* {product.card?.nmID} */}
                    {product.offer_id}
                  </Link>
                </div>

              </div>
            </TableCell>
            {mode === MODES[1] && (
              <>
                {pricesMode && (
                  <>
                    <TableCell width={WIDTH_POSTING[6]} center={true}>
                      <div style={{ fontSize: '16px' }}>
                        {data.prices?.price}
                      </div>
                      {
                        data.supply_id && (data.supply_id !== product.supply_id) &&
                        <div style={{ position: 'absolute' }}>
                          <div style={{ position: 'absolute', left: '18px', bottom: '5px', fontWeight: 'bold', fontSize: '13px', backgroundColor: '#9e51a071', padding: '2px 8px', borderRadius: '100px', color: '#0000008f' }}>{data.supply_id}</div>
                        </div>
                      }
                    </TableCell>
                    <TableCell width={WIDTH_POSTING[6]} center={true}>
                      <Column style={{ alignItems: 'center' }}>
                        <Input
                          style={{ marginBottom: '5px' }}
                          value={product.purchase || data.purchase} center
                          onBlur={(v) => changeProductsInSupply({ action: 'purchase', shop: product.shop, supplyId: product.supply_id, offerId: product.offer_id, value: +v })}
                        // onChange={(v) => changeProductsInSupply({ action: 'change_term', id: product._id, value: new Date(v) })}
                        />
                        {data.quantity > 1 && (
                          <div style={{ color: '#0000006d', fontSize: '15px' }}>{+((product.purchase || data.purchase) * data.quantity).toFixed(2)}</div>)}
                      </Column>
                    </TableCell>
                    <TableCell
                      width={WIDTH_POSTING[13]}
                      center
                    >
                      <Row>
                        <Column style={{ width: 'fit-content' }}>
                          <Text className={cn(data.profit?.is_minus && styles.red_text)}>
                            {Number.isFinite(data.profit?.percent) ? Math.ceil(data.profit?.percent) : '-'} %
                          </Text>
                        </Column>
                        <div style={{ marginLeft: '15px' }}>
                          <Text fontWeight={600} className={data.profit?.is_minus ? styles.red_text : styles.green_text}>
                            {Number.isFinite(data.profit?.percent) ? numberWithSpaces(Math.ceil(data.profit?.rub)) : '-'}
                          </Text>
                          <CommissionNdsBlock card={data} market={'WB'} />
                        </div>
                        <div style={{ marginLeft: '10px', backgroundColor: '#6d2d7052', borderRadius: '25px', padding: '4px 4px', color: '#000000a1', fontSize: '10px', fontWeight: 'bold' }}>{data.sale_schema?.toUpperCase()}</div>
                      </Row>
                    </TableCell>
                    <TableCell width={WIDTH_POSTING[16]} center>
                      <Input
                        bold={data.marginality?.is_fixed}
                        value={data.marginality?.percent} center onBlur={(v) => onChangeCard(product.offer_id, product.shop, 'percent', v)} />
                    </TableCell>
                    <TableCell width={WIDTH_POSTING[16]} center>
                      <Input
                        bold={data.marginality?.is_fixed}
                        value={data.marginality?.min_rub} center onBlur={(v) => onChangeCard(product.offer_id, product.shop, 'min_rub', v)} />
                    </TableCell>
                    <TableCell width={WIDTH_POSTING[17]} center>
                      <Button
                        style={{ marginLeft: '-10px' }}
                        onClick={() =>
                          onChangeCard(product.offer_id, product.shop, 'fixed_marginality', !data.marginality.is_fixed)
                        }>
                        <Icon style={{}} src={data.marginality?.is_fixed ? lock_icon : unlock_icon} width={20} />
                      </Button>
                    </TableCell>
                  </>
                )}


                <TableCell width={WIDTH_POSTING[7]} center={true}>

                  <ButtonWithTooltip
                    style={{
                      ...(product.postings?.length === 0 && { opacity: '40%' }),
                      fontSize: '22px', 'fontWeight': 600,
                    }}
                    // disabled={product.postings.length === 0}
                    tooltip={isOpenPostingsArray ? 'Скрыть список заказов' : 'Показать список заказов'}
                    onClick={() => setIsOpenPostingsArray(!isOpenPostingsArray)}
                  >
                    <Column style={{ alignItems: 'center' }}>
                      <Row >
                        {product.total?.sold.count === product.ordered_quantity && product.total?.cancel.count === 0 ? (
                          <span style={{ color: '#01800eab' }}>{product.total?.sold.count}</span>
                        ) : (
                          <>
                            {product.total?.delivery.count > 0 && (<span style={{ color: '#807e01ab' }}>{product.total?.delivery.count}</span>)}
                            {(product.total?.delivery.count > 0 && product.total?.sold.count > 0) && (<span> / </span>)}
                            {product.total?.sold.count > 0 && (<span style={{ color: '#01800eab' }}>{product.total?.sold.count}</span>)}
                            {((product.total?.sold.count + product.total?.delivery.count) > 0 && product.total?.cancel.count > 0) && (<span> / </span>)}
                            {product.total?.cancel.count > 0 && (<span style={{ color: '#ff00006e' }}>{product.total?.cancel.count}</span>)}
                            {((product.total?.cancel.count + product.total?.sold.count + product.total?.delivery.count) > 0 && product.total?.cancel.return_pvz_count > 0) && (<span> / </span>)}
                            {product.total?.cancel.return_pvz_count > 0 && (<span style={{ color: '#870000a5' }}>{product.total?.cancel.return_pvz_count}</span>)}
                            {(product.total?.cancel.count + product.total?.sold.count + product.total?.delivery.count + product.total?.cancel.return_pvz_count) > 0 && (<span> / </span>)}
                            {product.processed_quantity}
                            {/* <span style={{ color: '#637108ff' }}>{product.all_count}</span> /  */}
                          </>
                        )}
                        <span style={{ color: '#00000065', fontSize: '17px' }}> ({Object.keys(_.groupBy(product.postings, 'group_number')).length})</span>
                      </Row>
                      {product.last_order_date &&
                        <Row style={{ color: '#00000065', fontSize: '12px' }}>
                          {moment(product.last_order_date).format('DD-MM-YYYY HH:mm')}
                        </Row>
                      }
                    </Column>
                  </ButtonWithTooltip>
                </TableCell>
                {(tab === 7 || tab === 8) && (
                  <>
                    <TableCell width={WIDTH_POSTING[6]} center={true}>
                      <div style={{ fontSize: '22px', color: '#242000bd', 'fontWeight': 600 }} >{product.accepted_quantity}</div>
                    </TableCell>
                    <TableCell width={WIDTH_POSTING[6]} center={true}>
                      <div style={{ fontSize: '22px', color: '#6b0000bd', 'fontWeight': 600 }} >{product.planned_quantity - product.accepted_quantity}</div>
                    </TableCell>
                    <TableCell width={WIDTH_POSTING[6]} center={true}>
                      <div style={{ fontSize: '22px', color: '#686b00bd', 'fontWeight': 600 }} >{product.unloading_quantity}</div>
                    </TableCell>
                  </>
                )}
              </>
            )}
            {mode === MODES[0] && (
              <>
                <TableCell width={WIDTH_POSTING[16]} center={true}>
                  <Input
                    updateValue={{}}
                    fontSize={mode === MODES[0] ? '25px' : '22px'}
                    fontWeight={'600'}
                    center
                    // disabled={!product.boxes?.box_number}
                    max={product.ordered_quantity - product.processed_quantity}
                    value={product.boxes?.quantity || 0}
                    onBlur={(v) => changeProductsInSupply({ quantity: +v, shop: product.shop, supplyId: product.supply_id, action: 'change_quantity_in_box', offerId: product.offer_id, boxId: product._id })}
                  />
                </TableCell>

              </>
            )}

            <TableCell width={WIDTH_POSTING[0]}>
              <ProviderList width='130px' selectProviderId={product.provider_id} disabled={true} />
            </TableCell>
            {mode === MODES[0] &&
              <TableCell width={WIDTH_POSTING[16]} center={true}>
                <div style={{ marginTop: '7px', color: '#000000d0', fontSize: mode === MODES[0] ? '25px' : '16px', ...(mode === MODES[0] && { 'fontWeight': 600 }) }} className={styles.div_line}>
                  {product.quantity}
                </div>
              </TableCell>
            }

            {mode !== MODES[0] && <TableCell width={WIDTH_POSTING[5]}>
              <Input value={product.provider_artnumber} disabled={true} center={true} />
            </TableCell>}
            {mode === MODES[1] && (
              <>
                {isOwner && (
                  <TableCell width={WIDTH_POSTING[4]} center>
                    <ProfitBlock
                      profit={{
                        total: product.total?.total.profit,
                        total_by_report: product.total_report?.total.profit,

                        return_pvz: -product.total?.cancel.return_pvz,
                        cancel: product.total?.cancel.profit,

                        cancel_by_report: product.total_report?.cancel.profit,

                        sold: product.total?.sold.profit,
                        sold_by_report: product.total_report?.sold.profit,

                        return_blocked: product.total_return_blocked,

                        potential_sale: {
                          count: product.processed_quantity - product.total?.sold.count - product.total?.cancel.return_pvz_count,
                          profit: data.profit?.rub
                        }
                      }}
                    />
                  </TableCell>)}
                <TableCell width={WIDTH_POSTING[6]} center>
                  <div style={{
                    color: '#603b01c3',
                    fontSize: '20px',
                    'fontWeight': 600,
                    ...((product?.total_storage === 0 || product?.total_storage === null) && { opacity: '50%' }),
                  }}>
                    -{numberWithSpaces(Math.ceil(product?.total_storage))}
                  </div>
                </TableCell>
                <TableCell width={WIDTH_POSTING[6]} center>
                  {/* {(product.accepted_quantity - product?.total?.sold?.count - product?.total?.cancel?.return_pvz_count) === } */}
                  <div style={{
                    color: '#1d1c1bc3',
                    fontSize: '20px',
                    'fontWeight': 600,
                    ...(product?.warehouse_mp_stock === 0 && { opacity: '50%' }),
                  }}>
                    {product?.warehouse_mp_stock}
                    {product?.warehouse_mp_stock !== (product.accepted_quantity || 0) - (product.blocked_returns || []).length - product.total?.delivery.count - product?.total?.sold?.count - product?.total?.cancel?.return_pvz_count && (
                      <span style={{ color: '#1d1c1b75', fontSize: '18px', 'fontWeight': 600 }}> / {(product.accepted_quantity || 0) - (product.blocked_returns || []).length - product?.total?.sold?.count - product.total?.delivery.count - product?.total?.cancel?.return_pvz_count}</span>
                    )}
                  </div>
                </TableCell>
                <TableCell width={WIDTH_POSTING[8]} center>
                  <Column style={{ alignItems: 'center' }}>
                    {/* {(product.storage_days_count < (moment().diff(product.first_day, 'days') || 0)) && */}
                    {(product.warehouse_mp_stock === 0 && product.accepted_quantity > 0) &&
                      <div style={{ color: '#000000c3', fontSize: '18px', 'fontWeight': 600 }}>
                        {product.storage_days_count || 1}
                      </div>
                    }
                  </Column>
                </TableCell>
                <TableCell width={WIDTH_POSTING[16]} center>
                  <Column style={{ alignItems: 'center' }}>
                    <div style={{ color: product.warehouse_mp_stock === 0 ? '#00000057' : '#000000c3', fontSize: '18px', 'fontWeight': 600 }}>
                      {moment().diff(product.first_day, 'days') || 0}{' '}
                    </div>
                    <div style={{ marginTop: '3px', color: '#0000007b', fontSize: '12px' }}>{product.first_day ? moment(product.first_day).format('DD.MM.YYYY') : '-'}</div>
                  </Column>
                </TableCell>

                <TableCell width={WIDTH_POSTING[16]} center>
                  <div style={{ color: '#000000c3', fontSize: '16px', 'fontWeight': 600 }}>
                    {product.orders_in_day}
                  </div>
                </TableCell>
                <TableCell width={WIDTH_POSTING[8]} center>
                  <div style={{ color: '#000000c3', fontSize: '16px', 'fontWeight': 600 }}>
                    {(!product.warehouse_mp_stock || !product.orders_in_day) ? '' : Math.ceil(product.warehouse_mp_stock / (product.orders_in_day)) || ''}
                  </div>
                </TableCell>

                {/* <TableCell width={WIDTH_POSTING[6]} center>
                  <Column style={{ alignItems: 'center' }}>
                    <div style={{ color: '#000000c3', fontSize: '16px', 'fontWeight': 600 }}>
                      {product.last_order_date ? moment(product.last_order_date).format('MM-DD-YYYY') : '-'}
                    </div>
                  </Column>
                </TableCell> */}
              </>
            )}
            {mode !== MODES[1] && (
              <>

                <TableCell width={WIDTH_POSTING[16]} center>
                  <Input
                    value={data.sizes_package?.depth}
                    onBlur={(v) => onChangeCard(product.offer_id, product.shop, 'depth', v)}
                    center
                  />
                </TableCell>
                <TableCell width={WIDTH_POSTING[16]} center>
                  <Input
                    value={data.sizes_package?.width}
                    onBlur={(v) => onChangeCard(product.offer_id, product.shop, 'width', v)}
                    center
                  />
                </TableCell>
                <TableCell width={WIDTH_POSTING[16]} center>
                  <Input
                    value={data.sizes_package?.height}
                    onBlur={(v) => onChangeCard(product.offer_id, product.shop, 'height', v)}
                    center
                  />
                </TableCell>
                <TableCell width={WIDTH_POSTING[16]} center>
                  <Input
                    value={+(data.sizes_package?.volume)?.toFixed(2)}
                    disabled
                    center
                  />
                </TableCell>
                {/* <TableCell width={WIDTH_POSTING[16]} center>
                  <Input
                    value={square}
                    disabled
                    center
                  />
                </TableCell> */}
                {/* <TableCell width={WIDTH_POSTING[16]} center>
                  <Input
                    value={(+(square > 0.1 ? ((square - 0.1) / 0.1 * 2) : 0).toFixed(1)) + ' р.'}
                    disabled
                    center
                  />
                </TableCell>
                <TableCell width={WIDTH_POSTING[16]} center>
                  <Input
                    value={(+(square > 0.1 ? ((square - 0.1) / 0.1 * 2) : 0).toFixed(1) * product.ordered_quantity)}
                    disabled
                    center
                  />
                </TableCell> */}
                <TableCell width={WIDTH_POSTING[5]} center>
                  <DateInput
                    value={product.term}
                    className={styles.calendar}
                    onChange={(v) => changeProductsInSupply({ action: 'change_term', shop: product.shop, supplyId: product.supply_id, offerId: product.offer_id, boxId: product._id, value: new Date(v) })}
                  />
                </TableCell>
                <TableCell width={WIDTH_POSTING[3]} center>
                  <Row>
                    <PackagingMethodSelect
                      method={packageMethods.find(m => m._id === data?.packaging_method_id)?.method}
                      // disabled={!is_owner}
                      onSelect={(v) => onChangeCard(product.offer_id, product.shop, 'packaging_method', v._id)}
                    />
                  </Row>
                </TableCell>
                <TableCell width={WIDTH_POSTING[16]} center>
                  <Input
                    value={data.sizes_package?.weight}
                    onBlur={(v) => onChangeCard(product.offer_id, product.shop, 'weight', v)}
                    center
                  />
                </TableCell>

                <TableCell width={WIDTH_POSTING[7]}>
                  <BarcodesBlock
                    barcodes={product.barcodes}
                  // onAdd={(b) => onChangeProduct(order.posting_number, p._id, 'barcodes', b, 'add')}
                  // onRemove={(b) => onChangeProduct(order.posting_number, p._id, 'barcodes', b, 'pull')}
                  />
                </TableCell>
                <TableCell width={WIDTH_POSTING[15]} center>
                  <div style={{ cursor: 'pointer' }} onClick={() => { changeProductsInSupply({ action: 'delete_box', shop: product.shop, supplyId: product.supply_id, offerId: product.offer_id, boxId: product._id }) }}>
                    <img src={close} style={{ width: '15px' }} />
                  </div>
                </TableCell>
              </>
            )}

            {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
          </TableLine >
          {isOpenPostingsArray && (
            <Column style={{}} className={styles.history_block}>
              {/* <Column style={{overflowY: 'scroll',  maxHeight: '1000px'}} className={styles.history_block}> */}
              {_.sortBy(product.postings, 'dates.created_at', 'sticker_parts.full').map((p, i) => {
                return {
                  ...p,
                  next_posting_number: _.sortBy(product.postings, 'dates.created_at').slice(i + 1).find(pp => pp.posting_number !== p.posting_number && p.sticker_parts?.initial && pp.sticker_parts?.initial === p.sticker_parts?.initial)?.posting_number,
                  // next_posting_number_is_group: product.postings.slice(i + 1).find(pp => pp.posting_number !== p.posting_number && p.group_number && (pp.group_number === p.group_number))
                }
              }).map((posting, i) => (
                <Column>
                  <Row key={posting.posting_number}>
                    <div style={{ color: '#00000078', fontWeight: 'bold', minWidth: '20px' }}>{i + 1}</div>
                    <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>

                    <Column style={{ minWidth: '330px' }}>
                      <TextGrey style={{ color: '#0000007f' }}>Дата заказа: <span style={{ color: '#000000ff' }}>{moment(posting.dates.created_at).format('DD.MM.YYYY')} </span> <span style={{ fontSize: '13px', color: '#000000ad', marginTop: '4px' }}>{moment(posting.dates.created_at).format('HH:mm')} </span></TextGrey>
                      <TextGrey style={{ color: '#0000007f' }}>Стикер:  <span style={{ color: '#000000ff' }}> {posting.sticker_parts?.full} / {posting.sticker_parts?.initial} </span></TextGrey>
                      <span style={{ fontSize: '12px', color: '#0000007f' }}>Номер заказа:  <span style={{ color: '#000000b3' }}> {posting.posting_number} </span></span>
                      <span style={{ fontSize: '12px', color: '#0000007f' }}>id корзины:  <span style={{ color: '#000000b3' }}> {posting.group_number} </span></span>
                    </Column>
                    <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                    <Column style={{ minWidth: '210px' }}>
                      <div style={{ alignSelf: 'center', margin: '0px 0 10px' }}>
                        <PostingStatusWrap order={posting} ></PostingStatusWrap>
                      </div>
                      {(posting.products[0]?.commission?.increased_commission?.from_report || posting.products[0]?.commission?.returns?.from_report) && (
                        <div style={{ position: 'relative' }}>
                          <img src={okay3} style={{ position: 'absolute', left: '169px', bottom: '0px', width: '22px' }} />
                        </div>
                      )}
                      {posting.dates.sold_at && (
                        <TextGrey style={{ color: '#0000007f' }}>Дата продажи:  <span style={{ color: '#000000ff' }}> {getDate(posting.dates.sold_at)} </span></TextGrey>
                      )}
                      {posting.dates.canceled_at && (
                        <TextGrey style={{ color: '#0000007f' }}>Дата отмены:  <span style={{ color: '#000000ff' }}> {getDate(posting.dates.canceled_at)} </span></TextGrey>
                      )}
                    </Column>
                    {isOwner && (
                      <>
                        <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                        <Row style={{ minWidth: '240px' }}>
                          <Column>
                            <TextGrey style={{ color: '#0000007f' }}>Цена закупки:<div style={{ color: '#000000ff' }}> {+(posting.products[0].purchase * posting.products[0].common_quantity).toFixed()}</div></TextGrey>
                            {['Ожидает отгрузки', 'Продано'].includes(posting.status) && (<TextGrey style={{ color: '#0000007f' }}>Марж.:<div style={{ color: '#000000ff' }}> {+(posting.products[0]?.profit?.percent)?.toFixed(0)} %</div></TextGrey>)}
                          </Column>
                          <Column style={{ alignItems: 'flex-end', width: 'max-content' }}>
                            <div style={{ fontWeight: 'bold', color: posting.products[0]?.profit?.rub > 0 ? 'green' : 'red' }}>{posting.products[0]?.profit?.rub}</div>
                            <div style={{ marginLeft: '10px', width: 'max-content' }} className={styles.block_commission}>
                              <CommissionWbBlock
                                market={'wb'}
                                commission={posting.products[0]?.commission}
                              />
                            </div>

                          </Column>
                        </Row>
                        <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                        <Column style={{ minWidth: '250px' }}>
                          <TextGrey style={{ color: '#0000007f' }}>Цена продажи:<span style={{ color: '#000000ff' }}> {posting.products[0].price} руб.</span> {posting.products[0].price_report && (posting.products[0].price_report !== posting.products[0].price) && <span style={{ color: '#e11515ff' }}> / {posting.products[0].price_report} руб.</span>}  </TextGrey>
                          {posting.products[0].price_final && (<TextGrey style={{ color: '#0000007f' }}>Цена продажи (фин):<span style={{ color: '#000000ff' }}> {posting.products[0].price_final} руб.</span>  </TextGrey>)}
                        </Column>
                      </>
                    )}


                    {/* <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                  <Row center style={{ minWidth: '100px' }}>
                    <Text className={classNames(data.profit?.is_minus && styles.red_text)}>
                      {Number.isFinite(data.profit?.percent) ? Math.ceil(data.profit?.percent) : '-'} %
                    </Text>

                    <div className={styles.block_commission}>
                      <Text fontWeight={600} className={data.profit?.is_minus ? styles.red_text : styles.green_text}>
                        {Number.isFinite(data.profit?.percent) ? numberWithSpaces(Math.ceil(data.profit?.rub)) : '-'}
                      </Text>
                      <CommissionNdsBlock card={data} market={'WB'} />
                    </div>


                  </Row> */}

                    <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>

                    {(posting.review?.id || posting.way?.to) && (
                      <>
                        <Column style={{ minWidth: 'max-content' }} >
                          {posting.review.rating && <div style={{ width: 'max-content', }}><ReactStars size={16} value={posting.review.rating} activeColor={'rgb(255 56 5'} edit={false} /></div>}
                          {posting.review?.comment && (<TextGrey style={{ color: '#0000007f', width: 'max-content', maxWidth: '900px' }}>{posting.review.customer}:<div style={{ color: '#000000ff' }}> {posting.review?.comment}</div>  </TextGrey>)}
                          {posting.review?.pros && (<TextGrey style={{ color: '#0000007f', width: 'max-content', maxWidth: '900px' }}>Достоинства:<div style={{ width: 'max-content', color: '#000000ff' }}> {posting.review?.pros}</div>  </TextGrey>)}
                          {posting.review?.cons && (<TextGrey style={{ color: '#0000007f', width: 'max-content', maxWidth: '900px' }}>Недостатки:<div style={{ width: 'max-content', color: '#000000ff' }}> {posting.review?.cons}</div>  </TextGrey>)}
                          {posting.way?.to && <span style={{ fontSize: '14px', color: '#0000007f' }}>Регион:  <span style={{ fontSize: '16px', color: '#000000e1' }}>{posting.way?.to}</span></span>}
                          {posting.way?.to && <span style={{ fontSize: '14px', color: '#0000007f' }}>Округ:  <span style={{ fontSize: '16px', color: '#000000e1' }}>{posting.way?.to_okrug}</span></span>}
                        </Column>
                      </>
                    )}
                    {posting.next_posting_number &&
                      <>
                        <div style={{ margin: '0 15px', borderRight: '2px solid #00000046', display: 'flex', alignSelf: 'stretch' }}></div>
                        <Row style={{ minWidth: '220px' }}>
                          {posting.next_posting_number &&
                            (<div>{'-> '}{_.sortBy(product.postings, 'dates.created_at', 'sticker_parts.full').findIndex(p => p.posting_number === posting.next_posting_number) + 1} ({product.postings?.filter(p => p.sticker_parts?.initial === posting.sticker_parts?.initial).length})</div>)}
                        </Row>
                      </>}
                  </Row>
                  {posting.next_posting_number_is_group ?
                    <hr style={{ width: '100%' }}></hr>
                    :
                    <hr style={{ width: '100%' }}></hr>
                  }
                </Column>
              ))}
            </Column>
          )}
        </>) :
        (<>

          <TableLine
            style={{
              // backgroundColor: '#942222ff',
              backgroundImage: `linear-gradient(to right, #07e50e45 ${product.total?.total.count * 100 / maxDateOrdersCount}%, #ffffff0a 0% )`

            }}
          >
            <TableCell onClick={() => { getByDateStat(new Date(moment(product._id).format('YYYY-MM-DD'))) }} styles={styles.line_selected} style={{ cursor: 'pointer' }} width={WIDTH_POSTING[5]} center>
              <Text>{product._id ? getDate(product._id) : '-'}</Text>
            </TableCell>
            <TableCell width={WIDTH_POSTING[5]} center>
              <b>{product.total?.total.count}</b>
            </TableCell>
            <TableCell width={WIDTH_POSTING[5]} center>
              <b>{product.total?.sold.count}</b>
            </TableCell>
            <TableCell width={WIDTH_POSTING[5]} center>
              <b>{product.total?.cancel.count}</b>
            </TableCell>
            <TableCell width={WIDTH_POSTING[5]} center>
              <b style={{ color: product.total?.total.profit > 0 ? '#01800eca' : '#6e0000d9' }}> {numberWithSpaces(product.total_report?.total.profit)} руб.</b>
            </TableCell>
            <TableCell width={WIDTH_POSTING[5]} center>
              <b style={{ color: product.total?.total.profit > 0 ? '#67941aca' : '#6e0000d9' }}> {numberWithSpaces(product.total?.total.profit - product.total_report?.total.profit)} руб.</b>
            </TableCell>
          </TableLine >

        </>)
      }
    </React.Fragment >
  );
};

export default SupplyItemLine;
